import React, { useEffect, useState, useRef } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageStyle from "../../../Components/Layout/PageLayout";
import Table from "../../../Components/Table/Table";
import {
  FilterButton,
  ProDropFilter,
  SearchFilter,
  // ProDropFilter,
  // CalendarFilter2,
  // ActionButton,
} from "../../../Components/Search/Search";
import Pagination from "../../../Components/Pagination/Pagination";
import { useNavigate } from "react-router";
// import { URL } from "../../../../../utils/routes";
import { useDispatch, useSelector } from "react-redux";
import { TableActions } from "../../../Components/Misc/Actions";
// import { useApprovals } from "../../Vendors/VendorApprovals/useApprovals";
// import { FormatCurrency } from "../../../../../utils/functions/FormatCurrency";
// import { FilterButton } from "../../../Components/Search/Search";
import { format } from "date-fns";
import {
  GetApplicant,
  // AcceptOffer,
  // RejectOffer,
  // CloseOffer,
  ScheduleTnterviewWithCandidate,
  RescheduleTnterviewWithCandidate,
  MoveCandidateToSelected,
  AssignEmployeesToGrade,
  GetMetrics,
  submitApplicantGrade,
} from "../../../../../utils/redux/HR/HRSlice";
import { CTAButtons } from "../../../../global/components/Buttons/buttons";
import {
  // AiFillCaretLeft,
  // AiFillCaretRight,
  AiOutlineExclamationCircle,
} from "react-icons/ai";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { DEFINED_PERMISSIONS } from "../../../../../utils/const";
import { toast } from "react-toastify";
import {
  FormInputMax,
  FormsSelect,
  FormTemplate,
} from "../../../Components/Forms/InputTemplate";
import { FormProvider, useForm } from "react-hook-form";
import Select from "react-select";
import { GetAlLEmployees } from "../../../../../utils/redux/Vendor/VendorSlice";
import moment from "moment";

function ApplicantForJobListing({ data }) {
  const [status, setStatus] = useState(null);
  const [modalAction, setModalAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showScheduleInterviewModal, setShowScheduleInterviewModal] =
    useState(false);
  const modalRef = useRef(null);
  const [selectedPayrollId, setSelectedPayrollId] = useState(null);
  const [filter, setFilter] = useState(1);
  const [search, setSearch] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [action, setAction] = useState();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [refresh, setRefresh] = useState(false);

  const getRequest = useSelector((state) => state?.hr);
  const { get_applicant, get_metrics, isLoading } = getRequest;

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  let start =
    startDate === undefined ? "" : format(new Date(startDate), "DD/MM/YYYY");
  let end =
    endDate === undefined ? "" : format(new Date(endDate), "DD/MM/YYYY");

  const allEmployees = useSelector((state) => state?.vendor?.employees?.result);

  const { handleSubmit, setValue, reset } = useForm({
    defaultValues: {
      employeeArray: [],
    },
  });

  const apiData = {
    pageSize: pageSize,
    pageNumber: pageNumber,
    startDate: start,
    endDate: end,
    // action: action,
    search: search,
    JobListingId: data,
    InterviewStatus: filter,
  };

  useEffect(() => {
    dispatch(GetApplicant(apiData));
    dispatch(
      GetMetrics({
        pageSize: pageSize,
        pageNumber: pageNumber,
        approvalStatusEnum: 0,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    status,
    pageNumber,
    pageSize,
    search,
    startDate,
    endDate,
    action,
    refresh,
  ]);

  let applicant = get_applicant?.result;
  let metrics = get_metrics?.responseObject?.pageItems;

  const [searchTerm, setSearchTerm] = useState("");

  const filterBy = [
    // {
    //   name: "Approved",
    //   filter: 0,
    // },
    {
      name: "Pending",
      filter: 1,
    },
    {
      name: "Declined",
      filter: 7,
    },
    {
      name: "Cancelled",
      filter: 11,
    },
    {
      name: "Closed",
      filter: 2,
    },
    // {
    //   name: "Selected Applicant",
    //   filter: 5,
    // },
    // {
    //   name: "Accepted",
    //   filter: 4,
    // },
    // {
    //   ApprovedByEDO = 30,
    //  ApprovedByEDFI = 60,
    //  ApprovedByMD = 10,
    // }
    // {
    //   name: "ApprovedByED",
    //   filter: 30,
    // },
    // {
    //   name: "ApprovedByEDFI",
    //   filter: 60,
    // },
    // {
    //   name: "ApprovedByMD",
    //   filter: 10,
    // },
  ];

  const onSubmit = async (values) => {
    const userPayload = { ...values };

    const payload = {
      evaluatorId: userPayload.employeeArray.map((a) => a.value),
      applicantId: selectedPayrollId?.id,
      jobPostingId: selectedPayrollId?.jobPostingId,
      // metricId: 0,
      comment: "Attach Employee to Grade the Applicant",
    };

    try {
      const actionDispatchFunction = await dispatch(
        AssignEmployeesToGrade(payload)
      );
      if (actionDispatchFunction?.payload?.successful === true) {
        // Do something upon successful action
        setRefresh(!refresh);
        setShowModal(false);
        toast.success(actionDispatchFunction?.payload?.statusMessage);
      } else if (actionDispatchFunction?.payload?.successful === false) {
        toast.error(actionDispatchFunction?.payload?.statusMessage);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleOpenModal = (action, payrollId) => {
    setModalAction(action);
    setSelectedPayrollId(payrollId); // Assuming you're using a state to hold the currently selected ID
    if (action === "Interview" || action === "Reschedule") {
      setShowScheduleInterviewModal(true);
    } else {
      setShowModal(true);
    }
  };

  const handleCloseModal = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      setShowModal(false);
    }
  };

  const handleMoveToSelected = async () => {
    const payload = {
      applicantId: selectedPayrollId,
    };

    try {
      const actionDispatchFunction = await dispatch(
        MoveCandidateToSelected(payload)
      );
      if (actionDispatchFunction?.payload?.successful === true) {
        // Do something upon successful action
        setRefresh(!refresh);
        setShowModal(false);
        toast.success(actionDispatchFunction?.payload?.statusMessage);
      } else if (actionDispatchFunction?.payload?.successful === false) {
        toast.error(actionDispatchFunction?.payload?.statusMessage);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleCloseModal);
    return () => {
      document.removeEventListener("mousedown", handleCloseModal);
    };
  }, []);

  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    const permSelect = allEmployees?.map((a) => ({
      value: a.id,
      label: a.firstName + " " + a.surname,
    }));
    setEmployees(permSelect);
  }, [allEmployees]);

  useEffect(() => {
    dispatch(
      GetAlLEmployees({
        pageSize: 100000,
        pageNumber: 1,
      })
    );
  }, []);

  return (
    <PageStyle
      title={"Schedule Interview"}
      hasBack={false}
      // action={actionButton}
      isMain={true}
    >
      <div className={DashboardStyle.dashboard_filter}>
        <SearchFilter
          text={(value) => setSearchTerm(value)}
          onChange={(e) => setSearchTerm(e.target.value)}
          value={searchTerm}
        />

        <ProDropFilter
          filter={filter}
          setFilter={setFilter}
          name={"Status"}
          filterBy={filterBy}
        />

        <FilterButton onClick={() => setRefresh(!refresh)} name="" />
      </div>
      <div className={DashboardStyle.dashboard_table_holder}>
        <Table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Date of Birth</th>
              <th>Email</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Other Name</th>
              <th>Location</th>
              <th>Phone</th>
              <th>interview Status</th>
              <th>Offer Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {applicant?.map((acq, index) => (
              <AcqTable
                {...acq}
                index={index}
                isLoading={isLoading}
                key={index}
                handleOpenModal={handleOpenModal}
                data={acq}
              />
            ))}
          </tbody>
        </Table>
      </div>
      {/* <Pagination
        last_page={data?.totalPages}
        present_page={data?.currentPage}
        totalRows={data?.pageSize}
        pageSize={pageSize}
        setPageSize={(page) => setPageSize(page)}
        click={(page) => setPageNumber(page)}
      /> */}

      {showModal && modalAction === "Selected" && (
        <div className={DashboardStyle.modalOverlay}>
          <div className={DashboardStyle.modal1} ref={modalRef}>
            <div className={DashboardStyle.modalcontent1}>
              <div className={DashboardStyle.cycler}>
                <AiOutlineExclamationCircle
                  size={24}
                  style={{ color: "brown" }}
                />
              </div>
              <h1 style={{ textAlign: "center", fontSize: "20px" }}>
                {modalAction === "Selected"
                  ? "Are you sure you want to move this applicant to the selected list ?"
                  : ""}
              </h1>
            </div>

            <div className={DashboardStyle.modalfooter1}>
              <button
                className={DashboardStyle.greenButton}
                onClick={handleMoveToSelected}
              >{`Yes, ${modalAction}`}</button>
              <button
                onClick={() => setShowModal(false)}
                className={DashboardStyle.whiteButton2}
              >
                No, Close
              </button>
            </div>
          </div>
        </div>
      )}

      {showModal && modalAction === "Assign" && (
        <div className={DashboardStyle.modalOverlay}>
          <div className={DashboardStyle.modal1} ref={modalRef}>
            <div className={DashboardStyle.modalcontent1}>
              {/* <div className={DashboardStyle.cycler}>
                <AiOutlineExclamationCircle
                  size={24}
                  style={{ color: "brown" }}
                />
              </div> */}
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  margin: "20px 0",
                }}
              >
                {modalAction === "Assign" ? "Assign Employees" : ""}
              </h1>

              <label htmlFor="" className="form__label">
                Employees
              </label>
              <Select
                options={employees}
                isMulti={true}
                onChange={(value) => setValue("employeeArray", value)}
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </div>

            <div className={DashboardStyle.modalfooter1}>
              <button
                className={DashboardStyle.greenButton}
                // onClick={handleAssignEmployee}
                onClick={handleSubmit(onSubmit)}
              >{`Yes, ${modalAction}`}</button>
              <button
                onClick={() => setShowModal(false)}
                className={DashboardStyle.whiteButton2}
              >
                No, Close
              </button>
            </div>
          </div>
        </div>
      )}

      {showScheduleInterviewModal && (
        <ScheduleInterviewModal
          isOpen={showScheduleInterviewModal}
          onClose={() => setShowScheduleInterviewModal(false)}
          modalAction={modalAction}
          selectedPayrollId={selectedPayrollId}
          refresh={refresh}
          setRefresh={setRefresh}
        />
      )}

      {showModal && modalAction === "Grade" && (
        <GradeApplicantModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          modalAction={modalAction}
          selectedPayrollId={selectedPayrollId}
          refresh={refresh}
          setRefresh={setRefresh}
          metrics={metrics}
        />
      )}
    </PageStyle>
  );
}

export default ApplicantForJobListing;

function AcqTable({
  dob,
  email,
  firstName,
  gender,
  isDone,
  jobPostingId,
  lastName,
  maritalStatus,
  otherName,
  phone,
  interviewStatus,
  website,
  location,
  handleOpenModal,
  index,
  uuId,
  data,
  offerStatus,
}) {
  const navigate = useNavigate();

  const [matchedPermissionHr, setMatchedPermissionHr] = useState("");

  useEffect(() => {
    const userPerm = JSON.parse(localStorage.getItem("x-u-perm"));
    const hrPerm = [
      DEFINED_PERMISSIONS.SeniorHRManager,
      DEFINED_PERMISSIONS.PrimaryHRManager,
      // DEFINED_PERMISSIONS.HRManager,
    ];

    // Check if userPerm exists and matches any permission in hrPerm
    if (userPerm && userPerm.some((perm) => hrPerm.includes(perm))) {
      const matchedPerm = userPerm.find((perm) => hrPerm.includes(perm));
      setMatchedPermissionHr(matchedPerm); // Set matchedPermissionHr to the matched permission
    } else {
      setMatchedPermissionHr(""); // Reset to empty string if not matched
    }
  }, []);

  return (
    <>
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{FormatDateTime(dob, "ll")} </td>
        <td>{email}</td>
        <td>{firstName}</td>
        <td>{lastName}</td>
        <td>{otherName}</td>
        <td>{location}</td>
        <td>{phone}</td>
        <td>
          {interviewStatus === 1
            ? "Pending"
            : interviewStatus === 0
            ? "Approved"
            : interviewStatus === 7
            ? "Declined"
            : interviewStatus === 11
            ? "Cancelled"
            : interviewStatus === 2
            ? "Closed"
            : interviewStatus === 5
            ? "Selected"
            : interviewStatus === 4
            ? "Accepted"
            : interviewStatus === 30
            ? "ApprovedByED"
            : interviewStatus === 60
            ? "ApprovedByEDFI"
            : interviewStatus === 10
            ? "ApprovedByMD"
            : ""}
        </td>
        <td>
          {offerStatus === 1
            ? "Pending"
            : offerStatus === 0
            ? "Approved"
            : offerStatus === 7
            ? "Declined"
            : offerStatus === 11
            ? "Cancelled"
            : offerStatus === 2
            ? "Closed"
            : offerStatus === 5
            ? "Selected"
            : offerStatus === 4
            ? "Accepted"
            : offerStatus === 30
            ? "ApprovedByED"
            : offerStatus === 60
            ? "ApprovedByEDFI"
            : offerStatus === 10
            ? "ApprovedByMD"
            : ""}
        </td>
        <td>
          <TableActions
            hasChildren={true}
            url={`/dashboard/hr/recruitment-service/${data?.id}/view`}
          >
            {[
              {
                name: "Schedule Interview",
                action: () => handleOpenModal("Interview", data),
              },
              {
                name: "Reschedule Interview",
                action: () => handleOpenModal("Reschedule", data),
              },
              {
                name: "Assign Employee",
                action: () => handleOpenModal("Assign", data),
              },
              {
                name: "Grade",
                action: () => handleOpenModal("Grade", data),
              },
              {
                name: "Move to Selected",
                action: () => handleOpenModal("Selected", data?.id),
              },
            ]}
          </TableActions>
        </td>
      </tr>
    </>
  );
}

const ScheduleInterviewModal = ({
  isOpen,
  onClose,
  modalAction,
  selectedPayrollId,
  refresh,
  setRefresh,
}) => {
  const formMethods = useForm({ mode: "all" });
  const dispatch = useDispatch();
  const {
    handleSubmit,
    formState: { isValid },
  } = formMethods;

  if (!isOpen) return null;

  const submit = async (data) => {
    const options = {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    };
    const payloadForInterview = {
      applicantId: selectedPayrollId?.id,
      scheduleDate: data.date,
      interviewType: Number(data.interviewType),
      time: moment(data?.time, "HH:mm").format("h:mm A"),
    };

    const payloadForReschedule = {
      interviewScheduleId: Number(selectedPayrollId?.interviewSchedules[0]?.id),
      rescheduledDate: data.date,
      interviewType: Number(data.interviewType),
      time: moment(data?.time, "HH:mm").format("h:mm A"),
    };
    console.log("payload interview", payloadForInterview);
    try {
      const actionDispatchFunction =
        modalAction === "Interview"
          ? await dispatch(ScheduleTnterviewWithCandidate(payloadForInterview))
          : await dispatch(
              RescheduleTnterviewWithCandidate(payloadForReschedule)
            );
      if (actionDispatchFunction?.payload?.successful === true) {
        // Do something upon successful action
        setRefresh(!refresh);
        onClose();
        toast.success(actionDispatchFunction?.payload?.statusMessage);
      } else if (actionDispatchFunction?.payload?.successful === false) {
        toast.error(actionDispatchFunction?.payload?.statusMessage);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center"
      onClick={onClose}
    >
      <div
        className="relative mx-auto p-5 border w-96 shadow-lg rounded-md bg-white"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-lg font-semibold text-gray-900 mb-4">
          Schedule Interview
        </h2>
        <FormProvider {...formMethods}>
          <FormTemplate handleSubmit={handleSubmit(submit)}>
            <div className="mb-4">
              <FormsSelect
                title={"Interview Type"}
                camelCase={"interviewType"}
                placeholder={"Select Interview Type"}
                array={[
                  <option key={0} value={0}>
                    Test
                  </option>,
                  <option key={1} value={1}>
                    Physical Meeting
                  </option>,
                  <option key={2} value={2}>
                    Virtual Meeting
                  </option>,
                ]}
                required={true}
              />
            </div>

            <div className="mb-4">
              <FormInputMax
                title={"Date"}
                camelCase={"date"}
                type="date"
                required={true}
              />
            </div>

            <div className="mb-4">
              <FormInputMax
                title={"Time"}
                camelCase={"time"}
                type="time"
                required={true}
              />
            </div>

            <div className={DashboardStyle.button_cage}>
              <button
                type="button"
                onClick={() => onClose()}
                className="px-6 py-2 bg-gray-100 text-gray-800 border border-gray-300 rounded-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={!isValid}
                className="px-6 py-2 bg-green-600 text-white rounded-md"
              >
                Submit
              </button>
            </div>
          </FormTemplate>
        </FormProvider>
      </div>
    </div>
  );
};

const GradeApplicantModal = ({
  isOpen,
  onClose,
  modalAction,
  selectedPayrollId,
  refresh,
  setRefresh,
  metrics,
}) => {
  const formMethods = useForm({ mode: "all" });
  const dispatch = useDispatch();
  const {
    handleSubmit,
    reset,
    formState: { isValid },
  } = formMethods;

  const userId = JSON.parse(localStorage.getItem("user"));
  if (!isOpen) return null;

  const submit = async (data) => {
    // Construct the payload
    const payload = {
      ApplicantId: selectedPayrollId?.id || null,
      JobPostingId: selectedPayrollId?.jobPostingId || null,
      EvaluatorId: userId?.userId || null,
      MetricCommands: metrics.map((metric) => ({
        metricId: metric.id,
        value: Number(data[metric.name]),
      })),
    };

    try {
      const response = await dispatch(submitApplicantGrade(payload));
      if (response?.payload?.successful) {
        setRefresh(!refresh);
        onClose();
        toast.success(response?.payload?.statusMessage);
      } else {
        toast.error(response?.payload?.statusMessage);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center"
      onClick={onClose}
    >
      <div
        className="relative mx-auto p-5 border w-[450px] shadow-lg rounded-md bg-white"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-lg font-semibold text-gray-900 mb-4">
          Grade Applicant
        </h2>
        <FormProvider {...formMethods}>
          <FormTemplate handleSubmit={handleSubmit(submit)}>
            <section className="mb-4 w-full">
              {metrics?.map((metric, index) => {
                if (index % 2 === 0) {
                  return (
                    <div
                      key={index}
                      className="flex w-full items-center space-x-4 mb-4"
                    >
                      <FormInputMax
                        title={`${metrics[index]?.name} (0 - ${metrics[index]?.rate})`}
                        camelCase={metrics[index]?.name}
                        type="number"
                        required={true}
                        placeholder={`Rate ${metrics[index]?.name}`}
                        className="flex-1"
                        style={{ width: "200px" }}
                        max={metrics[index]?.rate}
                        onInput={(e) => {
                          if (e.target.value > metrics[index]?.rate) {
                            e.target.value = metrics[index]?.rate;
                          }
                        }}
                      />
                      {metrics[index + 1] && (
                        <FormInputMax
                          title={`${metrics[index + 1]?.name} (0 - ${
                            metrics[index + 1]?.rate
                          })`}
                          camelCase={metrics[index + 1]?.name}
                          type="number"
                          required={true}
                          placeholder={`Rate ${metrics[index + 1]?.name}`}
                          className="flex-1"
                          style={{ width: "200px" }}
                          max={metrics[index + 1]?.rate}
                          onInput={(e) => {
                            if (e.target.value > metrics[index + 1]?.rate) {
                              e.target.value = metrics[index + 1]?.rate;
                            }
                          }}
                        />
                      )}
                    </div>
                  );
                }
                return null;
              })}
            </section>

            <div className="flex justify-end space-x-4">
              <button
                type="button"
                onClick={() => onClose()}
                className="px-6 py-2 bg-gray-100 text-gray-800 border border-gray-300 rounded-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={!isValid}
                className="px-6 py-2 bg-green-600 text-white rounded-md"
              >
                Submit
              </button>
            </div>
          </FormTemplate>
        </FormProvider>
      </div>
    </div>
  );
};
